import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isFieldType } from '@core-engine/schema/field-type-guards/is-field-type.js'

export function isSupportedSchemaFieldType(field: SchemaField): boolean {
  return typeof field.type === 'string' && isFieldType(field.type)
}
